/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import { SaveButton, Toolbar as RaToolbar } from "react-admin";

export const Toolbar = (props) => (
  <RaToolbar {...props}>
    <SaveButton disabled={props.pristine} />
  </RaToolbar>
);
